import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-SaveSearchQueryBuiilder" */'shared-components/components/QueryBuilder'));
